import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { getCandidateInitialValues } from 'selectors/candidates';
import Candidate from 'types/candidates';
import { rejectPendingCandidate, downloadAttachedFile } from '../actions';

const useReviewPendingCandidate = (
  candidate: Candidate,
  candidateId: number | string | undefined
) => {
  const dispatch = useDispatch();

  const rejectPendingCandidateHandler = useCallback(
    () => dispatch(rejectPendingCandidate(candidateId)),
    [dispatch, candidateId]
  );

  const downloadAttachedFileHandler = useCallback(
    (type: string, id: string | number | undefined) => () =>
      dispatch(downloadAttachedFile({ type, id })),
    [dispatch]
  );

  const candidateInitialValues = getCandidateInitialValues(candidate);

  const loading = useSelector<any, boolean>(state => state.loading);

  return {
    rejectPendingCandidateHandler,
    downloadAttachedFileHandler,
    candidateInitialValues,
    loading,
  };
};

export default useReviewPendingCandidate;
